import { GameLiveConnection } from '../../services/liveConnection';
import { DefaultQueryParams } from '../constants/defaultQueryParams';
import { parseQuery } from '../helpers/parseQuery';
import { environmentBuilder } from '../helpers/environmentBuilder';
import { detectSocketPath } from '../constants/socketPathName';
import { GameIds, ROUND_GAMES_GAME_IDS } from '../constants/gameIds';
import { applicationStore } from '../../store/applicationStore';

let timeOutId;

export class MainGameConnection extends GameLiveConnection {
  gameConnections = {
    /* eslint-disable global-require */
    [GameIds.Plinko]: () => {
      const { plinkoGameConnection } = require('../../games/plinko/plinkoConnection/index');
      return plinkoGameConnection.executeGameConnections();
    },
    [GameIds.Limbo]: () => {
      const { limboGameConnection } = require('../../games/limbo/limboConnection/index');
      return limboGameConnection.executeGameConnections();
    },
    [GameIds.Crash]: () => {
      const { crashGameConnection } = require('../../games/crash/crashConnection/index');
      return crashGameConnection.executeGameConnections();
    },
    [GameIds.BlackJack]: () => {
      const {
        blackJackGameConnection,
      } = require('../../games/blackjack/blackJackConnection/index');
      return blackJackGameConnection.executeGameConnections();
    },
    [GameIds.Hilo]: () => {
      const { hiloGameConnection } = require('../../games/hilo/hiloConnection/index');
      return hiloGameConnection.executeGameConnections();
    },
    [GameIds.Dice]: () => {
      const { diceGameConnection } = require('../../games/dice/diceConnection/index');
      return diceGameConnection.executeGameConnections();
    },
    [GameIds.Wheel]: () => {
      const { wheelGameConnection } = require('../../games/wheel/wheelConnection/index');
      return wheelGameConnection.executeGameConnections();
    },
    [GameIds.Keno]: () => {
      const { kenoGameConnection } = require('../../games/keno/kenoConnection/index');
      return kenoGameConnection.executeGameConnections();
    },
    [GameIds.Roulette]: () => {
      const { rouletteGameConnection } = require('../../games/roulette/rouletteConnection/index');
      return rouletteGameConnection.executeGameConnections();
    },
    [GameIds.Baccarat]: () => {
      const { baccaratGameConnection } = require('../../games/baccarat/baccaratConnection/index');
      return baccaratGameConnection.executeGameConnections();
    },
    [GameIds.Mines]: () => {
      const { minesGameConnection } = require('../../games/mines/minesConnection/index');
      return minesGameConnection.executeGameConnections();
    },
    [GameIds.AlternativeDice]: () => {
      const {
        alternativeDiceConnection,
      } = require('../../games/alternativeDice/alternativeDiceConnection/index');
      return alternativeDiceConnection.executeGameConnections();
    },
    [GameIds.CoinFlip]: () => {
      const { coinFlipGameConnection } = require('../../games/coinFlip/coinFlipConnection/index');
      return coinFlipGameConnection.executeGameConnections();
    },
    [GameIds.Fishing]: () => {
      const { fishingGameConnection } = require('../../games/fishing/fishingConnection/index');
      return fishingGameConnection.executeGameConnections();
    },
    [GameIds.Drift]: () => {
      const { driftGameConnection } = require('../../games/drift/driftConnection/index');
      return driftGameConnection.executeGameConnections();
    },
    [GameIds.Football]: () => {
      const { footballGameConnection } = require('../../games/football/footballConnection/index');
      return footballGameConnection.executeGameConnections();
    },
    [GameIds.DoubleDice]: () => {
      const {
        doubleDiceGameConnection,
      } = require('../../games/doubleDice/doubleDiceConnection/index');
      return doubleDiceGameConnection.executeGameConnections();
    },
    [GameIds.Limbo10]: () => {
      const { limbo10GameConnection } = require('../../games/limbo10/limbo10Connection/index');
      return limbo10GameConnection.executeGameConnections();
    },
    [GameIds.FastTrade]: () => {
      const {
        fastTradeGameConnection,
      } = require('../../games/fastTrade/fastTradeConnection/index');
      return fastTradeGameConnection.executeGameConnections();
    },
    [GameIds.HandBlackJack]: () => {
      const {
        handBlackJackGameConnection,
      } = require('../../games/handBlackjack/handBlackjackConnection/index');
      return handBlackJackGameConnection.executeGameConnections();
    },
    [GameIds.Tower]: () => {
      const { towerGameConnection } = require('../../games/tower/towerConnection/index');
      return towerGameConnection.executeGameConnections();
    },
    [GameIds.PowerOfGods]: () => {
      const {
        powerOfGodsGameConnection,
      } = require('../../games/powerOfGods/powerOfGodsConnection/index');
      return powerOfGodsGameConnection.executeGameConnections();
    },
    /* eslint-enable global-require */
  };

  constructor(url) {
    super(url);
  }

  async sendGameGetInitialState(isInitial = true) {
    const {
      [DefaultQueryParams.PartnerId]: partnerId,
      [DefaultQueryParams.GameId]: gameId,
      [DefaultQueryParams.GameTypeId]: gameTypeId,
    } = parseQuery(window.location.search);

    if (isInitial) {
      this.gameConnections[gameId]();
      this.executeGlobalConnections();
    }
    if (ROUND_GAMES_GAME_IDS.includes(+gameId)) {
      await super.sendGetInitialState({ partnerId, gameTypeId, gameId, isDemo: false });
    } else {
      await super.sendGetInitialState({ partnerId });
    }
  }

  socketRecursiveReconnecting(executeConnections) {
    try {
      this.stop()
        .then(() => {
          this.init().then(() => {
            this.sendGameGetInitialState(executeConnections).then(() => {
              applicationStore.setIsSocketConnected(true);
            });
          });
          clearTimeout(timeOutId);
        })
        .catch(() => {
          timeOutId = setTimeout(() => {
            this.socketRecursiveReconnecting();
          }, 4000);
        });
    } catch (err) {
      applicationStore.setIsConnectionLost(true);
    }
  }

  executeGlobalConnections() {
    super.onReconnecting();
    super.onReconnected();
    super.onClose();
    super.onBalanceUpdate();
    super.onGameOpen();
    super.onHandleUnauthorizedError();
  }
}

const { socketUrl } = environmentBuilder(detectSocketPath(window.location.pathname));

export const mainGameConnection = new MainGameConnection({ url: `${socketUrl}game` });
